angular.module('picmonicng').directive('playlistBlock', [
  '$timeout',
  function ($timeout) {
    return {
      restrict: 'E',
      templateUrl: '/templates/directives/playlist-block.html',
      link: function (scope, element, attrs) {
        $timeout(function () {
          if (scope.playlist_id) {
            scope.scrollToActivePlaylist();
          }
        });
      },
    };
  },
]);
